import React from 'react'
import { ChecklistPreview } from '@awell/ui-kit/components/ChecklistPreview'
import { ActivityStatus } from '../../../../hooks/useChecklistActivity'
import { Activity } from '../../types'

interface ChecklistData {
  disabled: boolean
  onSubmit: () => Promise<void>
  title: string
  items: Array<any>
}

interface Props {
  checklistData: ChecklistData
  activity: Activity
  onClose: () => void
}

export const ChecklistTab: React.FC<Props> = ({ checklistData, activity, onClose }) => {
  const handleSubmitChecklist = async () => {
    await checklistData.onSubmit()
    onClose()
  }

  return (
    <ChecklistPreview
      title={checklistData.title}
      items={checklistData.items}
      onSubmit={handleSubmitChecklist}
      readOnly={activity.status !== ActivityStatus.Active}
      disabled={checklistData.disabled}
    />
  )
}
